// extracted by mini-css-extract-plugin
export default {"bg":"Overlay_bg__2pLm0","on":"Overlay_on__pJssg"};